import type { Breakpoint, SxProps, Theme } from "@mui/material/styles";

import { useTheme } from "@mui/material/styles";
import { useCallback, useState } from "react";

import { NavigationSidebarSxProps, NavigationSlotsProps } from "../types";
import { NavigationMobileButton } from "./NavigationMobileButton";
import { NavigationMobileDrawer } from "./NavigationMobileDrawer";

export type NavigationMobileProps = NavigationSidebarSxProps &
  NavigationSlotsProps & {
    breakpointTo: Breakpoint;
    sxButton?: SxProps<Theme>;
  };

export const NavigationMobile = ({
  breakpointTo,
  slots,
  sxButton,
  sxSidebar,
}: NavigationMobileProps) => {
  const theme = useTheme();
  const [isNavigationOpen, setIsNavigationOpen] = useState(false);

  const onClick = useCallback(() => {
    setIsNavigationOpen(true);
  }, []);

  return (
    <>
      <NavigationMobileButton
        onClick={onClick}
        sx={{
          ml: -1,
          [theme.breakpoints.up(breakpointTo)]: { display: "none" },
          ...sxButton,
        }}
      />
      <NavigationMobileDrawer
        isOpen={isNavigationOpen}
        onClose={() => setIsNavigationOpen(false)}
        slots={slots}
        sxSidebar={sxSidebar}
      />
    </>
  );
};
